import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, Image, HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaLinkedin } from 'react-icons/fa';

const MotionBox = motion(Box);

const WhyUsTeam = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="brand.50">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.subtitle}
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} w="full">
            {data.members.map((member, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box
                  p={6}
                  bg="white"
                  borderRadius="2xl"
                  boxShadow="0 4px 20px rgba(0,0,0,0.08)"
                  _hover={{
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(16,185,129,0.2)',
                  }}
                  transition="all 0.3s"
                  textAlign="center"
                >
                  <VStack spacing={4}>
                    <Image
                      src={member.image}
                      alt={member.name}
                      borderRadius="full"
                      boxSize="150px"
                      objectFit="cover"
                    />
                    <VStack spacing={2}>
                      <Heading size="md" color="brand.800">
                        {member.name}
                      </Heading>
                      <Text color="accent.green" fontWeight="600">
                        {member.role}
                      </Text>
                      <Text color="brand.500" fontSize="sm">
                        {member.expertise}
                      </Text>
                    </VStack>
                    <HStack spacing={3}>
                      <FaLinkedin size={20} color="#10B981" />
                    </HStack>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default WhyUsTeam;